import React from 'react';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@material-ui/core';
import { AppSlider } from './InputComponents';
import useStyles from "./FPQNumbers.style";

const FPQNumbers = props => {
    const classes = useStyles();

    return (
        <Box className={classes.root}>
            {/* Header */}
            {props.error && !props.validator.allValid() && (
        <Typography color="error">Please review your answers</Typography>
      )}
            <Box><ShowChartIcon className={classes.textIcon} /></Box>
            <Typography variant="h4" className={classes.title}>My Family Planning Goal</Typography>
            <Typography className={classes.subTitle}>
            </Typography>
            {/* Current Children Qty */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">How many children do you currently have?</Typography>
                <AppSlider
                    valueLabelDisplay="on"
                    min={0}
                    max={10}
                    value={props.currentChildrenQty}
                    onChange={props.onCurrentChildrenQtyChange}
                    marks={[
                        {
                            value: 0,
                            label: '0',
                        },
                        {
                            value: 10,
                            label: '10',
                        },
                    ]}
                />
            </Box>

            {/* thoughtAboutDesChildren */}


            <Box className={classes.inputSection}>
            <Typography variant="h5">
            Have you thought about how many children you desire?
              {
                <span
                  className={
                    props.error && !props.validator.fieldValid("thoughtAboutDesChildren")
                      ? `${classes.asteriskError}`
                      : `${classes.asteriskNormal}`
                  }
                >
                  *
                </span>
              }
            </Typography>
            <FormControl
              component="fieldset"
              error={props.error && !props.validator.fieldValid("thoughtAboutDesChildren")}
            >
              <RadioGroup
                row
                aria-label="Thought About Desired Children"
                value={props.thoughtAboutDesChildren}
                onChange={props.handleThoughtAboutDesChildren}
              >
                {["Yes", "No", "Undecided"].map((answer, i) => (
                  <FormControlLabel
               
                    key={i}
                    value={answer}
                    control={<Radio color="primary" />}
                    label={answer}
                  />
                ))}
              </RadioGroup>
              <FormHelperText style={{color:'red'}}>
                
                {props.validator.message(
                  "thoughtAboutDesChildren",
                  props.thoughtAboutDesChildren,
                  "required"
                )}
              </FormHelperText>
            </FormControl>
            </Box>
            
            {/* Desired Children Qty */}
            {props.thoughtAboutDesChildren && props.thoughtAboutDesChildren === "Yes" && 
            (<Box className={classes.inputSection}>
                <Typography variant="h5">How many children would you like to have?</Typography>
                <AppSlider
                    valueLabelDisplay="on"
                    min={0}
                    max={10}
                    value={props.desiredChildrenQty}
                    onChange={props.onDesiredChildrenQtyChange}
                    marks={[
                        {
                            value: 0,
                            label: '0',
                        },
                        {
                            value: 10,
                            label: '10',
                        },
                    ]}
                />
            </Box>)
}
        </Box>
    );
};

export default FPQNumbers;